import React, { useEffect, useState } from 'react';
export default function Popup({text, children, button, action, btnclasses}) {

   const [open, setOpen] = useState(false);
   useEffect(()=>{
      if(action === 'open'){
         setOpen(true);
      }
      if(action === 'close'){
         setOpen(false);
      }
   },[action]);


   return (
      <>
         {/* <button onClick={()=>setOpen(true)} className={btnclasses}>{text}</button> */}
         <div className={`modal basicmodal ${open ? 'show' : ''}`} >
            <div className="modal-dialog modal-dialog-centered" role="document">
               <div className="modal-content">
                  <button onClick={() => setOpen(false)} type="button" className="close" data-dismiss="modal" aria-label="Close">
                     <span aria-hidden="true">&times;</span>
                  </button>
                  <div className="modal-body">
                     {children}
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}
